/**
 * Producent + zabudowa, dla których dokument Certificate of Conformity ma
 * dedykowaną logikę biznesową (podpola wersji, tabele mas, itd.) - zamiast
 * porównywać w kodzie gołe stringi (`key === "Iveco Tourist Line"`), używamy
 * tego enuma.
 *
 * Wartości MUSZĄ dokładnie odpowiadać kluczom zwracanym przez
 * `buildProducerConversionKey(producentName, conversionName)`
 * (certificate-of-conformity-variables.constants.ts) - w tym spacja na końcu
 * `MercedesTouristLineHighDeck`, wynikająca z tego, że `conversionName` w
 * danych zamówienia ma tam spację na końcu ("Tourist Line HighDeck ").
 *
 * @module vehicle-line
 */
export enum VehicleLine {
  IvecoTouristLine = "Iveco Tourist Line",
  MercedesTouristLine = "Mercedes Benz Tourist Line",
  // UWAGA: spacja na końcu jest zamierzona - patrz komentarz wyżej.
  MercedesTouristLineHighDeck = "Mercedes Benz Tourist Line HighDeck ",
}

/**
 * Rzutuje klucz producent+zabudowa (z `buildProducerConversionKey`) na
 * `VehicleLine`, jeśli odpowiada jednej z obsługiwanych kombinacji.
 *
 * @param producerConversionKey - Wynik `buildProducerConversionKey(...)`
 * @returns Dopasowana wartość enuma lub null, jeśli kombinacja nie ma dedykowanej logiki
 */
export function resolveVehicleLine(
  producerConversionKey: string | undefined | null,
): VehicleLine | null {
  if (!producerConversionKey) return null;
  const values = Object.values(VehicleLine) as string[];
  return values.includes(producerConversionKey)
    ? (producerConversionKey as VehicleLine)
    : null;
}
